import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';

export const LIST_ITEM_TOP_MARGIN = getSpacingToken('50');

export const ListElement = styled.div`
    position: relative;
    text-align: left;
    box-sizing: border-box;
    outline: none;
    width: 100%;
    color: ${getToken('textStaticPrimary')};
    background-color: ${getToken('backgroundStaticFlat')};
    overflow-y: auto;
    padding: ${getSpacingToken('100')}px;

    & > div + div {
        margin-top: ${LIST_ITEM_TOP_MARGIN}px;
    }
`;
